/* All prices are NOK øre. These tiers mirror the scoped Shopify automatic discounts.
 * Changing this file does not update Shopify: keep server rules in sync.
 */
globalThis.OikosCoffeePricing = {
  currency: 'NOK',
  sizes: {
    'assefa-120g': { tiers: [{ min: 1, price: 10500 }, { min: 8, price: 9900 }, { min: 16, price: 9400 }, { min: 24, price: 8900 }] },
    'assefa-225g': { tiers: [{ min: 1, price: 18900 }, { min: 6, price: 15900 }, { min: 12, price: 14900 }, { min: 18, price: 13900 }] },
    'assefa-1kg': { tiers: [{ min: 1, price: 64900 }, { min: 4, price: 59900 }, { min: 8, price: 54900 }, { min: 12, price: 49900 }] },
    'espresso-250g': { tiers: [{ min: 1, price: 17900 }, { min: 6, price: 15900 }, { min: 12, price: 14500 }, { min: 18, price: 13500 }] },
    'espresso-1kg': { tiers: [{ min: 1, price: 59900 }, { min: 4, price: 49900 }, { min: 8, price: 45900 }, { min: 12, price: 43900 }] }
  },
  quote(key, quantity, eligibleQuantity = quantity) {
    const tiers = this.sizes[key]?.tiers;
    if (!tiers || !Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(eligibleQuantity) || eligibleQuantity < quantity) return null;
    const tier = [...tiers].reverse().find(tier => eligibleQuantity >= tier.min);
    if (!tier || !Number.isSafeInteger(tier.price * quantity)) return null;
    return {
      unit: tier.price,
      total: tier.price * quantity,
      discount: Math.round((1 - tier.price / tiers[0].price) * 100),
      next: tiers.find(tier => tier.min > eligibleQuantity) || null
    };
  }
};
